module.exports = "<div class=\"countdown row\">\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownDays }}</p>\n\t\t<p class=\"metric\">Days</p>\n\t</div>\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownHours }}</p>\n\t\t<p class=\"metric\">Hours</p>\n\t</div>\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownMinutes }}</p>\n\t\t<p class=\"metric\">Mins</p>\n\t</div>\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownSeconds }}</p>\n\t\t<p class=\"metric\">Secs</p>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/countdown/template.html
// module id = 845
// module chunks = 1